module.exports = __webpack_public_path__ + "static/media/ca.4a3c41ae.png";